import {createAsyncThunk} from '@reduxjs/toolkit';
import type {PremiumUpsellData} from './premium-upsell-panel.types';

export const getPremiumUpsellData = createAsyncThunk('getPremiumUpsellData', async (featureName: string): Promise<PremiumUpsellData> => {
  return (await window.PMW.readLocal('premium/premiumOnlyDialogData', {featureName})) as PremiumUpsellData;
});
